// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1fSO7","table":"styles_table___8pbY","wrapper":"styles_wrapper__3tHPh"};